
export default function Features() {
  const features = [
    {
      icon: 'ri-mail-line',
      title: 'Automatic Email Capture',
      description: 'Seamlessly captures invoices from your email inbox without any manual intervention.',
      image: 'https://public.readdy.ai/ai/img_res/87f2937c327a1d88f5f0b33ee66a5a06.jpg'
    },
    {
      icon: 'ri-scan-line',
      title: 'Smart Data Extraction',
      description: 'AI-powered OCR technology extracts vendor, amount, date, and line items with 99.9% accuracy.',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20OCR%20technology%20scanning%20invoice%20document%20with%20data%20extraction%20visualization%2C%20AI%20processing%20invoice%20information%20with%20highlighted%20text%20fields%2C%20modern%20tech%20interface%20showing%20automated%20data%20capture%2C%20professional%20document%20processing%20system&width=500&height=300&seq=data-extraction&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Secure Image Storage',
      description: 'Bank-level encryption ensures your invoice images are stored safely and compliantly.',
      image: 'https://readdy.ai/api/search-image?query=Secure%20digital%20vault%20with%20encrypted%20documents%20and%20invoice%20files%2C%20professional%20cybersecurity%20concept%20with%20lock%20icons%20and%20protected%20data%20storage%2C%20modern%20cloud%20security%20interface%2C%20blue%20security%20elements%20and%20shields&width=500&height=300&seq=secure-storage&orientation=landscape'
    },
    {
      icon: 'ri-check-double-line',
      title: 'Manual Approval Workflow',
      description: 'Review and approve invoices before posting with customizable approval rules.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20approval%20workflow%20interface%20showing%20invoice%20review%20process%2C%20clean%20dashboard%20with%20approval%20buttons%20and%20invoice%20details%2C%20modern%20business%20application%20with%20organized%20approval%20queue%2C%20efficient%20workflow%20management%20system&width=500&height=300&seq=approval-workflow&orientation=landscape'
    },
    {
      icon: 'ri-calendar-schedule-line',
      title: 'Smart Scheduling',
      description: 'Set up automated processing schedules that work around your business hours.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20scheduling%20interface%20with%20calendar%20view%20and%20automated%20processing%20timeline%2C%20professional%20business%20calendar%20with%20invoice%20processing%20schedules%2C%20clean%20time%20management%20dashboard%2C%20organized%20workflow%20scheduling%20system&width=500&height=300&seq=scheduling&orientation=landscape'
    },
    {
      icon: 'ri-link-line',
      title: 'Direct Integration',
      description: 'Posts directly to QuickBooks and MSBC without manual data entry or exports.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20accounting%20software%20integration%20showing%20seamless%20data%20flow%20between%20systems%2C%20QuickBooks%20and%20accounting%20platform%20connections%2C%20modern%20business%20software%20integration%20dashboard%2C%20automated%20posting%20and%20synchronization%20interface&width=500&height=300&seq=integration&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Powerful Features Built for SMBs
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Everything you need to automate your invoice processing workflow from capture to posting.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col lg:flex-row items-start gap-6">
              <div className="flex-shrink-0">
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className="w-full lg:w-80 h-48 object-cover object-top rounded-xl shadow-lg"
                />
              </div>
              <div className="flex-1">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
